var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.messageHeader !== null && _vm.messageHeader.type && _vm.messageHeader.msg && _vm.messageHeader.msg != '' && _vm.messageHeader.type != '' ? _c('div', {
    staticClass: "sticky top-0 z-20"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_c('div', {
    staticClass: "flex justify-center"
  }, [_c('div', {
    staticClass: "absolute flex items-center justify-center text-center text-base p-5 mt-10 w-max max-w-3/4 border-2",
    class: {
      'bg-green-300 border-green-600 border-opacity-25 text-green-600': _vm.messageHeader.type === 'success',
      'bg-amber-100 border-amber-600 border-opacity-25 text-amber-600': _vm.messageHeader.type === 'warning',
      'bg-pink-300 border-2 border-pink-600 border-opacity-25 text-pink-600': _vm.messageHeader.type === 'error',
      'bg-amber-100 border-2 border-amber-600 border-opacity-25 text-amber-600': _vm.messageHeader.type === 'INPUT'
    }
  }, [_c('div', [_c('div', {
    staticClass: "flex items-baseline justify-center"
  }, [_vm.messageHeader.type === 'success' ? _c('icon', {
    staticClass: "inline-block mr-2",
    attrs: {
      "name": "checkmark-circle-2"
    }
  }) : _vm.messageHeader.type === 'warning' ? _c('icon', {
    staticClass: "inline-block mr-2",
    attrs: {
      "name": "alert-circle"
    }
  }) : _vm.messageHeader.type === 'error' || _vm.messageHeader.type == 'INPUT' ? _c('icon', {
    staticClass: "inline-block mr-2",
    attrs: {
      "name": "alert-circle"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-lg"
  }, [_vm._v("\n              " + _vm._s(_vm.messageHeader.msg) + "\n            ")])], 1), _vm._v(" "), _vm.messageHeader.type == 'INPUT' ? _c('div', {
    staticClass: "mt-5"
  }, [_c('button', {
    staticClass: "border-amber-600 border-opacity-25 text-amber-600 bg-amber-100 border-2 rounded-md transform hover:scale-110 duration-300 text-base p-2 mr-4",
    on: {
      "click": function ($event) {
        return _vm.cancel_nosave();
      }
    }
  }, [_vm._v("\n              ANNULER\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "bg-amber-600 text-amber-100 border-amber-100 border-opacity-25 border-2 rounded-md transform hover:scale-110 duration-300 text-base p-2",
    on: {
      "click": function ($event) {
        return _vm.quit_nosave();
      }
    }
  }, [_vm._v("\n              QUITTER\n            ")])]) : _vm._e()])])])])], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }